import { Component, ViewEncapsulation } from "@angular/core";
import { DomainBaseComponent } from "app/shared/domain-base.component";
import { DomainService } from "app/shared/domain.service";

@Component({
  selector: "uni-auto-notes-catalog-doc",
  standalone: false,
  templateUrl: "./auto-notes-catalog-doc.component.html",
  encapsulation: ViewEncapsulation.None,
  host: { class: "flex flex-col flex-1 overflow-hidden" },
})
export class AutoNotesCatalogDocComponent extends DomainBaseComponent {
  mdSrc = "/assets/docs/auto-notes-catalog.md";

  constructor(domainService: DomainService) {
    super(domainService);
    this.isPageReady = true;
  }
}
